export enum NutrientType {
    Energy, 
    Fat, 
    SaturatedFattyAcids, 
    TransFattyAcids, 
    Cholesterol, 
    Sodium, 
    Carbohydrate, 
    Fibre, 
    Sugars, 
    Protein, 
    VitaminD, 
    Potassium, 
    Calcium, 
    Iron, 
    AddedSugars, 
    SugarAlcohols, 
    VitaminC, 
    Water,
    Erythritol = 30, 
    Isomalt, 
    Mannitol, 
    Xylitol, 
    Lactitol, 
    Sorbitol, 
    Maltitol, 
    UnspecifiedSugarAlcohol, 
    MonoUnsaturatedFats, // 38
    PolyUnsaturatedFats, // 39
    Omega3, // 40
    Omega6, // 41
    Biotin, // 42
    Choline, // 43
    Folate, // 44
    FolateDfe, // 45
    Niacin, // 46
    NiacinEq, // 47
    NiacinVitb3Eq, // 48
    PantothenicAcid, // 49
    Riboflavin, // 50
    Thiamine, // 51
    BetaCarotene, // 52
    Retinol, // 53
    VitaminB12, // 54 (Vitamin D, another form)
    VitaminE, // 55
    VitaminEToco, // 56
    VitaminETocoEq, // 57
    VitaminK, // 58
    Chromium, // 59
    Chloride, // 60
    Copper, // 61
    Iodine, // 62
    Magnesium, // 63
    Manganese, // 64
    Molybdenum, // 65
    Phosphorus, // 66
    Selenium, // 67
    Zinc, // 68
    LAlanine, // 69
    LArginine, // 70
    LAsparagine, // 71
    LAsparticAcid, // 72
    LCysteine, // 73
    LGlutamicAcid, // 74
    LGlutamine, // 75
    Glycine, // 76
    LHistidine, // 77
    LIsoleucine, // 78
    LLeucine, // 79
    LLysine, // 80
    LMethionine, // 81
    LPhenylalanine, // 82
    LProline, // 83
    LSerine, // 84
    LThreonine, // 85
    LTyrosine, // 86
    LValine, // 87
    Caffeine, // 88
    GreenTeaExtract, // 89
    Taurine, // 90
    Ash, // 91
    Moisture, // 92
    Other = 99
}